import React from 'react'
import K3Ball from './K3Ball'
const K3Balls = ({ addStake }) => {

  function addBall(ball){
    addStake(ball)
    console.log(ball)
  }

  return (
    <div className='bg-white rounded-lg grid grid-cols-4 gap-10 p-2 '>
      {Array.from({ length: 16 }, (_, i) => (
        <K3Ball i={i + 3} addBall={addBall}/>
        ))}
      </div>
  )
}

export default K3Balls